import apiurl from "./apiurl.js";
import axios from 'axios';

const consultaDLQ= {
    getDLQ: async (idToken) =>        
    axios({
        'method':'GET',
        'url':apiurl +'consultaDLQ',
        'headers': {
            'content-type':'application/json',
            'Authorization':"Bearer "+idToken
        },
        'crossdomain': true,
    }),
    redriveDLQ: async (queueName,idToken,maxMessagesPerSecond) =>        
    axios({
        'method':'POST',
        'url':apiurl +'redriveDLQ',
        'data': maxMessagesPerSecond
            ? {dlqKey:queueName, maxMessagesPerSecond}
            : {dlqKey:queueName},
        'headers': {
            'content-type':'application/json',
            'Authorization':"Bearer "+idToken
        },
        'crossdomain': true,
    })  
};

export default consultaDLQ;
